<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/GdXPQs/tc-custom/9781604603293.jpg?1704888701350" alt="This image is the cover for the book Forgiving Quilt, East Perry County Series"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Forgiving Quilt, East Perry County Series
      </h1>
      <p class="bookDescription body article font2">
        <b>Meet widowed Missouri transplant Kate Meyr in the first East Perry County mystery from the author of the Colebridge Community series.</b><br/><br/>Ann Hazelwood makes her return with <i>The Forgiving Quilt</i>, the first novel in the East Perry County Series. After the death of her husband brings out hurtful secrets, Kate Meyr strikes out to cleave her life from his. She vows to restore the property he left her in Borna, Missouri, and sell it, but the longer Kate stays in town, the harder she finds it to leave. Her life becomes even more embroiled in Borna when she discovers a mysterious quilt in her new home. Haunted by the quilt’s past, Kate is also troubled by several terrifying occurrences. Somebody wants to take the property from her. Will Kate let their horrifying tactics run her out, or will she stand her ground? Find out in this novel of self-discovery, forgiveness, and courage.<br/><br/><b>Praise for Ann Hazelwood and her novels</b><br/><br/>“I found myself immersed in the tale of this extended family and this wonderful quaint town . . . You will laugh, cry and share in their hopes and dreams.” —<i>Community News</i><br/><br/>“Ann Hazelwood knows a few things about the human spirit, family and dreaming big. Add a mixture of the love of quilting and all the things Missouri historic and otherwise; you will experience the words and passion of this unique and gifted author. Enjoy the experience!” —<i>StreetScape Magazine</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Ann Hazelwood
      </h2>
      
      <p class="authorDescription body article">Ann Hazelwood is a former shop owner and native of St. Charles, Missouri. She's always adored quilting and is a certified quilt appraiser. She's the author of the wildly successful Colebridge Community series and considers writing one of her greatest passions. Titles include: Colebridge Community series - The Basement Quilt, The Potting Shed Quilt, The Funeral Parlor Quilt, The Jane Austen Quilt Club, The Ghostly Quilts on Main, Quilted Lilies, A Colebridge Quilted Christmas.  She has also published the Wine Country Quilt Series, East Perry County series and is now writing the Door County Quilt series. booksonthings.com</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3a7bf366